import { render } from "./TextToSpeech.vue?vue&type=template&id=128cd535"
import script from "./TextToSpeech.vue?vue&type=script&lang=js"
export * from "./TextToSpeech.vue?vue&type=script&lang=js"

import "./TextToSpeech.vue?vue&type=style&index=0&id=128cd535&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__